var _defs, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _polygon, _path7, _g3, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _polygon2, _polygon3, _polygon4, _path15, _path16, _path17, _path18, _path19, _path20, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33, _polygon34, _polygon35, _polygon36, _polygon37, _polygon38, _polygon39, _polygon40, _polygon41, _polygon42, _polygon43, _polygon44, _polygon45, _polygon46, _polygon47, _polygon48, _polygon49, _polygon50, _polygon51, _polygon52, _polygon53, _polygon54, _polygon55, _polygon56, _polygon57, _polygon58, _polygon59, _polygon60, _polygon61, _polygon62, _polygon63, _polygon64, _polygon65, _polygon66, _polygon67, _polygon68, _polygon69, _polygon70, _polygon71, _polygon72, _polygon73, _polygon74, _polygon75, _polygon76, _polygon77, _polygon78, _polygon79, _polygon80, _polygon81, _polygon82, _polygon83, _polygon84, _polygon85, _polygon86, _polygon87, _polygon88, _polygon89, _polygon90, _polygon91, _polygon92, _polygon93, _polygon94, _polygon95, _path21, _path22, _path23, _polygon96, _polygon97, _polygon98, _polygon99, _polygon100, _polygon101, _path24, _path25, _path26, _path27, _path28, _path29, _polygon102, _polygon103, _polygon104, _path30, _path31, _path32, _polygon105, _polygon106, _polygon107, _polygon108, _polygon109, _polygon110, _polygon111, _polygon112, _polygon113, _polygon114, _polygon115, _polygon116, _polygon117, _polygon118, _polygon119, _polygon120, _polygon121, _polygon122, _path33, _polygon123, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _polygon124, _polygon125, _path55, _path56, _polygon126, _polygon127, _polygon128, _polygon129, _polygon130, _polygon131, _polygon132, _polygon133, _polygon134, _polygon135, _polygon136, _polygon137, _polygon138, _polygon139, _polygon140, _polygon141, _polygon142, _polygon143, _polygon144, _polygon145, _polygon146, _polygon147, _polygon148, _polygon149, _polygon150, _polygon151, _polygon152, _polygon153, _polygon154, _polygon155, _polygon156, _polygon157, _polygon158, _polygon159, _polygon160, _polygon161, _polygon162, _polygon163, _polygon164, _polygon165, _polygon166, _polygon167, _polygon168, _polygon169, _polygon170, _polygon171, _polygon172, _polygon173, _polygon174, _polygon175, _polygon176, _polygon177, _polygon178, _polygon179, _polygon180, _polygon181, _polygon182, _polygon183, _polygon184, _polygon185, _polygon186, _polygon187, _polygon188, _polygon189, _polygon190, _polygon191, _polygon192, _polygon193, _polygon194, _polygon195, _polygon196, _polygon197, _polygon198, _polygon199, _polygon200, _polygon201, _polygon202, _polygon203, _polygon204, _polygon205, _polygon206, _polygon207, _polygon208, _polygon209, _polygon210, _polygon211, _polygon212, _polygon213, _polygon214, _polygon215, _polygon216, _polygon217, _polygon218, _polygon219, _polygon220, _polygon221, _polygon222, _polygon223, _polygon224, _polygon225, _polygon226, _polygon227, _polygon228, _polygon229, _polygon230, _polygon231, _polygon232, _polygon233, _polygon234, _polygon235, _polygon236, _polygon237, _polygon238, _polygon239, _polygon240, _polygon241, _polygon242, _polygon243, _polygon244, _polygon245, _polygon246, _polygon247, _polygon248, _polygon249, _polygon250, _polygon251, _polygon252, _polygon253, _polygon254, _polygon255, _polygon256, _polygon257, _polygon258, _polygon259, _polygon260, _polygon261, _polygon262, _polygon263, _polygon264, _polygon265, _polygon266, _polygon267, _polygon268, _polygon269, _polygon270, _polygon271, _polygon272, _polygon273, _polygon274, _polygon275, _polygon276, _polygon277, _polygon278, _polygon279, _polygon280, _polygon281, _polygon282, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _g4, _g5, _path69, _polygon283, _polygon284, _polygon285, _polygon286, _polygon287, _polygon288, _polygon289, _polygon290, _polygon291, _polygon292, _polygon293, _polygon294, _polygon295, _polygon296, _polygon297, _polygon298, _polygon299, _polygon300, _polygon301, _polygon302, _polygon303, _path70, _path71, _path72, _path73, _path74, _path75;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWeb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "OBJECTS",
    viewBox: "0 0 234.49 233.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.4;}.cls-2,.cls-3{fill:#fff;}.cls-3{opacity:0.2;}.cls-4{fill:#f4767a;}.cls-5{fill:#ed5561;}.cls-6{fill:#bbcee1;}.cls-7{fill:#d8395a;}.cls-8{fill:#933e31;}.cls-9{fill:#1c75bc;}.cls-10{fill:#9d4d36;}.cls-11{fill:#a7bcce;}.cls-12{fill:#2a87c6;}.cls-13{fill:#e8ebf5;}.cls-14{fill:#0f4463;}.cls-15{fill:#0b3b56;}.cls-16{fill:#1f5e77;}.cls-17{fill:#07304b;}.cls-18{fill:url(#linear-gradient);}.cls-19{fill:#fed4bd;}.cls-20{fill:#f4c5a2;}.cls-21{fill:#de495a;}.cls-22{fill:#ef4136;}.cls-23{fill:#91a6b7;}.cls-24{fill:#79ff68;}.cls-25{fill:#50e85e;}.cls-26{fill:#3cc743;}.cls-27{fill:#9263c1;}.cls-28{fill:#8444b2;}.cls-29{fill:#7231a3;}.cls-30{fill:#ffa8e1;}.cls-31{fill:#ff7ad2;}.cls-32{fill:#de64c6;}.cls-33{fill:#fcec32;}.cls-34{fill:#f5d012;}.cls-35{fill:#eaa10c;}.cls-36{fill:#edf0f8;}.cls-37{fill:#f0cec9;}.cls-38{fill:#fffbf0;}.cls-39{fill:#f5ddd8;}.cls-40{fill:#dfbab8;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 87.3,
    y1: 132.44,
    x2: 104.57,
    y2: 75.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c75bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#2077bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#2b7ebc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#3e88bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5394bc"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1 slider") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "112.83 28.51 112.83 29.58 117.33 32.17 117.33 31.1 112.83 28.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "112.83 30.46 112.83 31.54 117.33 34.13 117.33 33.06 112.83 30.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "112.83 32.42 112.83 33.49 117.33 36.09 117.33 35.01 112.83 32.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "146.77 55.02 146.77 53.95 119.02 37.94 119.02 39.01 146.77 55.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "112.83 34.38 112.83 35.45 117.33 38.04 117.33 36.97 112.83 34.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "112.83 36.33 112.83 37.4 117.33 40 117.33 38.92 112.83 36.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "146.77 56.98 146.77 55.91 119.02 39.9 119.02 40.97 146.77 56.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "112.83 42.2 112.83 43.27 117.33 45.86 117.33 44.79 112.83 42.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "112.83 44.15 112.83 45.22 117.33 47.82 117.33 46.75 112.83 44.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "112.83 51.98 112.83 53.05 117.33 55.64 117.33 54.57 112.83 51.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "112.83 53.93 112.83 55 117.33 57.59 117.33 56.52 112.83 53.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "136.52 67.6 119.02 57.5 119.02 58.57 136.52 68.67 136.52 67.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "137.45 68.13 137.45 69.2 146.77 74.58 146.77 73.51 137.45 68.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "127.81 60.62 119.02 55.54 119.02 56.61 127.81 61.69 127.81 60.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "128.74 61.15 128.74 62.22 146.77 72.62 146.77 71.55 128.74 61.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "144.4 64.32 144.4 65.39 146.77 66.75 146.77 65.68 144.4 64.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "131.49 54.91 119.02 47.72 119.02 48.79 131.49 55.98 131.49 54.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "126.38 36.32 119.02 32.08 119.02 33.15 126.38 37.39 126.38 36.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "138.44 43.28 127.3 36.85 127.3 37.92 138.44 44.35 138.44 43.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "131.95 41.49 124.1 36.97 124.1 38.04 131.95 42.56 131.95 41.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "140.18 46.24 132.87 42.02 132.87 43.09 140.18 47.31 140.18 46.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "141.1 46.77 141.1 47.84 146.77 51.11 146.77 50.04 141.1 46.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "120.47 36.82 120.47 37.89 126.38 41.3 126.38 40.23 120.47 36.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "144.46 50.66 127.3 40.77 127.3 41.84 144.46 51.73 144.46 50.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "134.63 50.86 123.42 44.4 123.42 45.47 134.63 51.93 134.63 50.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "144.46 56.53 135.56 51.4 135.56 52.47 144.46 57.6 144.46 56.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "143.47 61.83 132.41 55.45 132.41 56.52 143.47 62.9 143.47 61.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "137.45 60.31 137.45 61.38 143.47 64.85 143.47 63.78 137.45 60.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "121.19 50.93 119.02 49.68 119.02 50.75 121.19 52 121.19 50.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "125.25 53.27 125.25 54.34 136.52 60.84 136.52 59.77 125.25 53.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "124.33 52.74 122.11 51.46 122.11 52.53 124.33 53.81 124.33 52.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "134.44 60.53 122.11 53.42 122.11 54.49 134.44 61.6 134.44 60.53"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "136.81 10.8 118.16 0 118.16 0.95 136.81 11.75 136.81 10.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "118.16 2.81 146.77 19.36 146.77 18.41 118.16 1.86 118.16 2.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "138.06 11.5 138.06 12.45 146.77 17.5 146.77 16.55 138.06 11.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "136.81 14.43 118.16 3.63 118.16 4.58 136.81 15.38 136.81 14.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "118.16 6.45 146.77 22.99 146.77 22.04 118.16 5.5 118.16 6.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "138.06 16.08 146.77 21.13 146.77 20.18 138.06 15.14 138.06 16.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "136.81 20.43 118.16 9.63 118.16 10.58 136.81 21.38 136.81 20.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "118.16 12.45 146.77 28.99 146.77 28.04 118.16 11.5 118.16 12.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "138.06 22.08 146.77 27.13 146.77 26.18 138.06 21.14 138.06 22.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "136.81 24.07 118.16 13.27 118.16 14.22 136.81 25.02 136.81 24.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "118.16 16.08 146.77 32.63 146.77 31.68 118.16 15.13 118.16 16.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "138.06 25.72 146.77 30.76 146.77 29.82 138.06 24.77 138.06 25.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "136.81 30.07 118.16 19.27 118.16 20.22 136.81 31.02 136.81 30.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "118.16 22.08 146.77 38.63 146.77 37.68 118.16 21.13 118.16 22.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "138.06 31.72 146.77 36.76 146.77 35.81 138.06 30.77 138.06 31.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "136.81 33.7 118.16 22.9 118.16 23.85 136.81 34.65 136.81 33.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "118.16 25.71 146.77 42.26 146.77 41.31 118.16 24.76 118.16 25.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "138.06 35.35 146.77 40.4 146.77 39.45 138.06 34.4 138.06 35.35"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M432.91,167l-13.93-8a1,1,0,0,0-1.53.88v16.67a2.25,2.25,0,0,0,1.14,2l13.93,8.06a1,1,0,0,0,1.56-.91V169A2.35,2.35,0,0,0,432.91,167Z",
    transform: "translate(-346.41 -142.59)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M426.73,181.06l-18.26-10.53a1.71,1.71,0,0,0-1.83.07h0l-4,2.31,1.86,2.53.7.8v18.09a3,3,0,0,0,1.5,2.61l13.67,7.91.14.76,2.79,3.91,4.29-2.53h0l0,0h0a1.36,1.36,0,0,0,.66-1.17v-22A3.14,3.14,0,0,0,426.73,181.06Z",
    transform: "translate(-346.41 -142.59)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M422.46,183.57,404,172.91a1.35,1.35,0,0,0-2,1.17V196.2a3,3,0,0,0,1.51,2.61l18.48,10.69a1.39,1.39,0,0,0,2.08-1.2v-22A3.14,3.14,0,0,0,422.46,183.57Z",
    transform: "translate(-346.41 -142.59)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M423.32,209.5l0,0h0Z",
    transform: "translate(-346.41 -142.59)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M424,208.3v-22a3.17,3.17,0,0,0-.21-1.06l4.28-2.47a2.94,2.94,0,0,1,.2,1v22a1.36,1.36,0,0,1-.66,1.17h0l0,0h0l-4.25,2.5A1.36,1.36,0,0,0,424,208.3Z",
    transform: "translate(-346.41 -142.59)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M406.35,183.5l-2.25-1.3,0,8.09,1.49.86v-2.88l.64.37a2.46,2.46,0,0,0,2,.48c.47-.19.71-.72.71-1.59a3.92,3.92,0,0,0-.66-2.27A5.56,5.56,0,0,0,406.35,183.5Zm.75,3.93a1.37,1.37,0,0,1-1-.28l-.49-.28v-2.4l.68.39a2.62,2.62,0,0,1,.89.81,1.92,1.92,0,0,1,.29,1.05C407.45,187.12,407.33,187.36,407.1,187.43Z",
    transform: "translate(-346.41 -142.59)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "67.75 48.59 64.97 46.98 64.98 43.81 63.48 42.95 63.46 51.04 64.95 51.9 64.96 48.41 67.75 50.02 67.74 53.51 69.23 54.37 69.25 46.28 67.76 45.42 67.75 48.59"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M421.23,192.73a5.56,5.56,0,0,0-1.94-1.76l-2.25-1.3,0,8.09,1.49.86v-2.87l.64.37a2.48,2.48,0,0,0,2,.47c.47-.19.71-.71.71-1.59A3.94,3.94,0,0,0,421.23,192.73ZM420,194.91a1.39,1.39,0,0,1-1-.29l-.49-.28v-2.4l.68.39a2.53,2.53,0,0,1,.89.81,1.93,1.93,0,0,1,.29,1.06C420.39,194.59,420.27,194.83,420,194.91Z",
    transform: "translate(-346.41 -142.59)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "37.19 39.29 37.19 40.36 41.69 42.96 41.69 41.89 37.19 39.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "37.19 41.25 37.19 42.32 41.69 44.91 41.69 43.84 37.19 41.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "37.19 43.2 37.19 44.27 41.69 46.87 41.69 45.8 37.19 43.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "71.13 65.8 71.13 64.73 43.38 48.73 43.38 49.8 71.13 65.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "37.19 45.16 37.19 46.23 41.69 48.82 41.69 47.75 37.19 45.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "37.19 47.11 37.19 48.19 41.69 50.78 41.69 49.71 37.19 47.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "71.13 67.76 71.13 66.69 43.38 50.68 43.38 51.75 71.13 67.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "37.19 52.98 37.19 54.05 41.69 56.65 41.69 55.58 37.19 52.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "37.19 54.94 37.19 56.01 41.69 58.6 41.69 57.53 37.19 54.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "37.19 62.76 37.19 63.83 41.69 66.42 41.69 65.35 37.19 62.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "37.19 64.71 37.19 65.78 41.69 68.38 41.69 67.31 37.19 64.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "60.88 78.38 43.38 68.28 43.38 69.35 60.88 79.45 60.88 78.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "61.81 78.91 61.81 79.98 71.13 85.36 71.13 84.29 61.81 78.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "52.17 71.4 43.38 66.33 43.38 67.4 52.17 72.47 52.17 71.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "53.09 71.93 53.09 73 71.13 83.4 71.13 82.33 53.09 71.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "68.76 75.1 68.76 76.17 71.13 77.54 71.13 76.47 68.76 75.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "55.84 65.7 43.38 58.5 43.38 59.57 55.84 66.77 55.84 65.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "50.74 47.1 43.38 42.86 43.38 43.93 50.74 48.17 50.74 47.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "62.8 54.06 51.66 47.64 51.66 48.71 62.8 55.13 62.8 54.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "56.31 52.27 48.46 47.75 48.46 48.82 56.31 53.34 56.31 52.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "64.54 57.02 57.23 52.81 57.23 53.88 64.54 58.09 64.54 57.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "65.46 57.55 65.46 58.62 71.13 61.89 71.13 60.82 65.46 57.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "44.83 47.61 44.83 48.68 50.74 52.09 50.74 51.02 44.83 47.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "68.82 61.44 51.66 51.55 51.66 52.62 68.82 62.52 68.82 61.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "58.99 61.65 47.78 55.18 47.78 56.25 58.99 62.72 58.99 61.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "68.82 67.31 59.92 62.18 59.92 63.25 68.82 68.38 68.82 67.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "67.83 72.61 56.77 66.23 56.77 67.3 67.83 73.68 67.83 72.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "61.81 71.09 61.81 72.16 67.83 75.64 67.83 74.57 61.81 71.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "45.55 61.71 43.38 60.46 43.38 61.53 45.55 62.78 45.55 61.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "49.61 64.06 49.61 65.13 60.88 71.63 60.88 70.56 49.61 64.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "48.69 63.52 46.47 62.24 46.47 63.31 48.69 64.59 48.69 63.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "58.8 71.31 46.47 64.2 46.47 65.27 58.8 72.38 58.8 71.31"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M517.7,195.8l-13.93-8a1,1,0,0,0-1.53.89v16.67a2.27,2.27,0,0,0,1.13,2l13.93,8.05a1,1,0,0,0,1.57-.9V197.83A2.36,2.36,0,0,0,517.7,195.8Z",
    transform: "translate(-346.41 -142.59)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M536.72,163.58l-13.93-8a1,1,0,0,0-1.53.88V173.1a2.24,2.24,0,0,0,1.14,2l13.93,8.06a1,1,0,0,0,1.56-.91v-16.6A2.32,2.32,0,0,0,536.72,163.58Z",
    transform: "translate(-346.41 -142.59)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M579.73,250.76l-13.93-8a1,1,0,0,0-1.53.88v16.68a2.24,2.24,0,0,0,1.14,2l13.92,8.06a1,1,0,0,0,1.57-.91v-16.6A2.32,2.32,0,0,0,579.73,250.76Z",
    transform: "translate(-346.41 -142.59)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M458.48,209.73l-13.93-8a1,1,0,0,0-1.52.89v16.67a2.28,2.28,0,0,0,1.13,2l13.93,8.05a1,1,0,0,0,1.57-.9V211.76A2.35,2.35,0,0,0,458.48,209.73Z",
    transform: "translate(-346.41 -142.59)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M406.05,346.76c-3.7,0-2.49-2.78-2.49-2.78-5.48-1.67-8.18-.74-8.18-.74a25.23,25.23,0,0,0-.87,8.94c0,.57.4.92.94,1.13,2.95,1.09,5.64,1.82,11.13,1.29,4.05-.4,8.33-4.14,7.36-8C413.33,344.22,409.8,346.72,406.05,346.76Z",
    transform: "translate(-346.41 -142.59)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M404.46,312c-1.08-1.41-2.94-2.61-6-1.8l-33.06,6.38,1.24,8.49a13.18,13.18,0,0,0,13.93,4.15,51.47,51.47,0,0,0,14.62-6.68L394.05,346a13.23,13.23,0,0,0,9.81-1.18c.77-.47,1.49-23.07,1.73-28.87A5.31,5.31,0,0,0,404.46,312Z",
    transform: "translate(-346.41 -142.59)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M421.92,353.54c-3.84,0-2.58-2.89-2.58-2.89-5.7-1.73-8.5-.77-8.5-.77a26.55,26.55,0,0,0-.91,9.28,1.26,1.26,0,0,0,1,1.18c3.07,1.14,5.86,1.89,11.56,1.34,4.2-.41,8.65-4.3,7.64-8.3C429.48,350.9,425.81,353.5,421.92,353.54Z",
    transform: "translate(-346.41 -142.59)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "37.93 201.62 9.55 185.21 9.55 189.21 37.94 205.57 37.93 201.62"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "35.35 170.39 9.55 185.21 37.93 201.62 63.76 186.78 35.35 170.39"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "63.76 186.78 37.93 201.62 37.94 205.57 63.76 190.63 63.76 186.78"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M420.27,317.44c-1.12-1.46-3-2.71-6.25-1.87l-34.33,6.62L381,331a13.68,13.68,0,0,0,14.46,4.31,53.29,53.29,0,0,0,15.18-6.94l-1.16,24.33a13.68,13.68,0,0,0,10.18-1.22c.81-.49,1.56-23.95,1.8-30A5.51,5.51,0,0,0,420.27,317.44Z",
    transform: "translate(-346.41 -142.59)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M358.93,267.78l58.62-34a8,8,0,0,1,8,0l92.34,53.42a3.53,3.53,0,0,1,0,6.12l-57.31,33.27a9.53,9.53,0,0,1-9.55,0l-92.13-53.3A3.16,3.16,0,0,1,358.93,267.78Z",
    transform: "translate(-346.41 -142.59)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M358.94,273.26l92.13,53.3a9.53,9.53,0,0,0,9.55,0l57.31-33.27a3.51,3.51,0,0,0,1.76-3v4.46h0a3.48,3.48,0,0,1-1.75,3L460.62,331a9.53,9.53,0,0,1-9.55,0l-92.13-53.3a3.15,3.15,0,0,1-1.59-2.77h0v-4.38A3.12,3.12,0,0,0,358.94,273.26Z",
    transform: "translate(-346.41 -142.59)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M358.94,273.26l92.13,53.3a9.45,9.45,0,0,0,4.36,1.25v4.42a9.57,9.57,0,0,1-4.36-1.25l-92.13-53.3a3.15,3.15,0,0,1-1.59-2.77h0v-4.38A3.12,3.12,0,0,0,358.94,273.26Z",
    transform: "translate(-346.41 -142.59)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M402.24,280.08l9.95-5.75a1.51,1.51,0,0,1,1.51,0l30.73,17.77a.67.67,0,0,1,0,1.15l-9.71,5.61a1.79,1.79,0,0,1-1.79,0l-30.69-17.74A.61.61,0,0,1,402.24,280.08Z",
    transform: "translate(-346.41 -142.59)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M402.24,281.12l30.69,17.74a1.79,1.79,0,0,0,1.79,0l9.71-5.61a.66.66,0,0,0,.33-.58v1.18h0a.7.7,0,0,1-.33.57L434.72,300a1.79,1.79,0,0,1-1.79,0L402.24,282.3a.57.57,0,0,1-.29-.52h0V280.6A.61.61,0,0,0,402.24,281.12Z",
    transform: "translate(-346.41 -142.59)"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "65.67 133.35 66.91 132.63 68.33 133.44 67.09 134.16 65.67 133.35"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "67.43 134.37 68.68 133.64 70.09 134.46 68.85 135.18 67.43 134.37"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "69.2 135.38 70.44 134.66 71.86 135.48 70.62 136.2 69.2 135.38"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "70.96 136.4 72.21 135.68 73.63 136.49 72.38 137.21 70.96 136.4"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "72.73 137.42 73.98 136.69 75.39 137.51 74.15 138.23 72.73 137.42"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "74.5 138.43 75.74 137.71 77.16 138.53 75.92 139.25 74.5 138.43"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "76.26 139.45 77.51 138.73 78.92 139.54 77.68 140.26 76.26 139.45"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "78.03 140.47 79.27 139.74 80.69 140.56 79.45 141.28 78.03 140.47"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "79.79 141.48 81.04 140.76 82.45 141.58 81.21 142.3 79.79 141.48"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "81.56 142.5 82.81 141.78 84.22 142.59 82.98 143.31 81.56 142.5"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "83.33 143.51 84.57 142.79 85.99 143.61 84.75 144.33 83.33 143.51"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "85.09 144.53 86.34 143.81 87.75 144.63 86.51 145.34 85.09 144.53"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "88.1 144.82 89.52 145.64 88.28 146.36 86.86 145.55 88.1 144.82"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "65.47 135.1 64.06 134.28 65.3 133.56 66.72 134.38 65.47 135.1"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "68.48 135.39 67.24 136.11 65.82 135.3 67.07 134.58 68.48 135.39"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "70.25 136.41 69.01 137.13 67.59 136.32 68.83 135.59 70.25 136.41"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "72.01 137.43 70.77 138.15 69.35 137.33 70.6 136.61 72.01 137.43"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "73.78 138.44 72.54 139.16 71.12 138.35 72.36 137.63 73.78 138.44"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "75.55 139.46 74.3 140.18 72.88 139.37 74.13 138.64 75.55 139.46"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "77.31 140.48 76.07 141.2 74.65 140.38 75.9 139.66 77.31 140.48"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "79.08 141.49 77.84 142.21 76.42 141.4 77.66 140.68 79.08 141.49"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "80.84 142.51 79.6 143.23 78.18 142.42 79.43 141.69 80.84 142.51"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "82.61 143.53 81.37 144.25 79.95 143.43 81.19 142.71 82.61 143.53"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "84.38 144.54 83.13 145.26 81.71 144.45 82.96 143.73 84.38 144.54"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "86.14 145.56 84.9 146.28 83.48 145.47 84.72 144.74 86.14 145.56"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "86.49 145.76 87.91 146.57 86.67 147.3 85.25 146.48 86.49 145.76"
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "63.86 136.03 62.44 135.22 63.69 134.5 65.1 135.31 63.86 136.03"
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "66.87 136.33 65.63 137.05 64.21 136.23 65.45 135.51 66.87 136.33"
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "65.97 137.25 67.22 136.53 68.64 137.34 67.39 138.06 65.97 137.25"
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "70.4 138.36 69.16 139.08 67.74 138.27 68.99 137.54 70.4 138.36"
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "72.17 139.38 70.93 140.1 69.51 139.28 70.75 138.56 72.17 139.38"
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "73.93 140.39 72.69 141.11 71.27 140.3 72.52 139.58 73.93 140.39"
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "75.7 141.41 74.46 142.13 73.04 141.32 74.28 140.59 75.7 141.41"
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "77.47 142.43 76.22 143.15 74.8 142.33 76.05 141.61 77.47 142.43"
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "79.23 143.44 77.99 144.16 76.57 143.35 77.82 142.63 79.23 143.44"
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "81 144.46 79.76 145.18 78.34 144.37 79.58 143.64 81 144.46"
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "82.76 145.48 81.52 146.2 80.1 145.38 81.35 144.66 82.76 145.48"
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "81.87 146.4 83.11 145.68 84.53 146.49 83.29 147.21 81.87 146.4"
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "84.88 146.69 86.3 147.51 85.05 148.23 83.63 147.41 84.88 146.69"
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "62.25 136.97 60.83 136.15 62.08 135.43 63.49 136.25 62.25 136.97"
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "62.6 137.17 63.84 136.44 65.26 137.26 64.02 137.98 62.6 137.17"
  })), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "64.36 138.18 65.61 137.46 67.02 138.28 65.78 139 64.36 138.18"
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "66.13 139.2 67.38 138.48 68.79 139.29 67.55 140.01 66.13 139.2"
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "67.89 140.22 69.14 139.49 70.56 140.31 69.31 141.03 67.89 140.22"
  })), _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "69.66 141.23 70.91 140.51 72.32 141.33 71.08 142.05 69.66 141.23"
  })), _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "71.43 142.25 72.67 141.53 74.09 142.34 72.85 143.06 71.43 142.25"
  })), _polygon51 || (_polygon51 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "73.19 143.27 74.44 142.54 75.85 143.36 74.61 144.08 73.19 143.27"
  })), _polygon52 || (_polygon52 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "74.96 144.28 76.2 143.56 77.62 144.38 76.38 145.1 74.96 144.28"
  })), _polygon53 || (_polygon53 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "76.72 145.3 77.97 144.58 79.39 145.39 78.14 146.11 76.72 145.3"
  })), _polygon54 || (_polygon54 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "78.49 146.32 79.74 145.59 81.15 146.41 79.91 147.13 78.49 146.32"
  })), _polygon55 || (_polygon55 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "80.26 147.33 81.5 146.61 82.92 147.43 81.68 148.15 80.26 147.33"
  })), _polygon56 || (_polygon56 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "83.27 147.63 84.68 148.44 83.44 149.16 82.02 148.35 83.27 147.63"
  })), _polygon57 || (_polygon57 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "60.64 137.9 59.22 137.09 60.47 136.36 61.88 137.18 60.64 137.9"
  })), _polygon58 || (_polygon58 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "60.98 138.1 62.23 137.38 63.65 138.19 62.41 138.91 60.98 138.1"
  })), _polygon59 || (_polygon59 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "62.75 139.12 64 138.4 65.41 139.21 64.17 139.93 62.75 139.12"
  })), _polygon60 || (_polygon60 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "64.52 140.13 65.76 139.41 67.18 140.23 65.94 140.95 64.52 140.13"
  })), _polygon61 || (_polygon61 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "66.28 141.15 67.53 140.43 68.94 141.25 67.7 141.97 66.28 141.15"
  })), _polygon62 || (_polygon62 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "68.05 142.17 69.3 141.44 70.71 142.26 69.47 142.98 68.05 142.17"
  })), _polygon63 || (_polygon63 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "69.81 143.18 71.06 142.46 72.48 143.28 71.23 144 69.81 143.18"
  })), _polygon64 || (_polygon64 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "71.58 144.2 72.83 143.48 74.24 144.29 73 145.01 71.58 144.2"
  })), _polygon65 || (_polygon65 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "73.35 145.22 74.59 144.49 76.01 145.31 74.77 146.03 73.35 145.22"
  })), _polygon66 || (_polygon66 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "75.11 146.23 76.36 145.51 77.77 146.33 76.53 147.05 75.11 146.23"
  })), _polygon67 || (_polygon67 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "76.88 147.25 78.12 146.53 79.54 147.34 78.3 148.06 76.88 147.25"
  })), _polygon68 || (_polygon68 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "78.64 148.27 79.89 147.54 81.31 148.36 80.06 149.08 78.64 148.27"
  })), _polygon69 || (_polygon69 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "81.66 148.56 83.07 149.38 81.83 150.1 80.41 149.28 81.66 148.56"
  })), _polygon70 || (_polygon70 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "58.85 137.3 60.27 138.11 59.03 138.83 57.61 138.02 58.85 137.3"
  })), _polygon71 || (_polygon71 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "62.03 139.13 60.79 139.85 59.37 139.03 60.62 138.31 62.03 139.13"
  })), _polygon72 || (_polygon72 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "63.8 140.15 62.56 140.87 61.14 140.05 62.38 139.33 63.8 140.15"
  })), _polygon73 || (_polygon73 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "65.57 141.16 64.33 141.88 62.91 141.07 64.15 140.34 65.57 141.16"
  })), _polygon74 || (_polygon74 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "67.33 142.18 66.09 142.9 64.67 142.08 65.92 141.36 67.33 142.18"
  })), _polygon75 || (_polygon75 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "69.1 143.19 67.86 143.91 66.44 143.1 67.68 142.38 69.1 143.19"
  })), _polygon76 || (_polygon76 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "69.45 143.4 71.21 144.41 71.22 144.41 71.56 144.61 72.98 145.43 72.98 145.43 73.7 145.84 74.75 146.44 74.75 146.44 75.86 147.09 77.93 148.28 76.69 149 74.53 147.75 73.5 147.17 73.5 147.17 72.43 146.55 71.73 146.15 71.74 146.15 70.34 145.35 69.97 145.13 69.97 145.13 68.2 144.12 69.45 143.4"
  })), _polygon77 || (_polygon77 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "79.69 149.29 78.45 150.01 77.03 149.2 78.28 148.48 79.69 149.29"
  })), _polygon78 || (_polygon78 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "81.46 150.31 80.22 151.03 78.8 150.22 80.04 149.49 81.46 150.31"
  })), _polygon79 || (_polygon79 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "90.39 147.58 91.63 146.86 93.05 147.67 91.81 148.39 90.39 147.58"
  })), _polygon80 || (_polygon80 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "92.16 148.6 93.4 147.87 94.82 148.69 93.57 149.41 92.16 148.6"
  })), _polygon81 || (_polygon81 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "93.92 149.61 95.17 148.89 96.58 149.71 95.34 150.43 93.92 149.61"
  })), _polygon82 || (_polygon82 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "91.44 148.61 90.2 149.33 88.78 148.51 90.02 147.79 91.44 148.61"
  })), _polygon83 || (_polygon83 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "93.2 149.62 91.96 150.34 90.54 149.53 91.79 148.81 93.2 149.62"
  })), _polygon84 || (_polygon84 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "94.97 150.64 93.73 151.36 92.31 150.55 93.55 149.82 94.97 150.64"
  })), _polygon85 || (_polygon85 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "89.83 149.54 88.58 150.26 87.17 149.45 88.41 148.72 89.83 149.54"
  })), _polygon86 || (_polygon86 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "91.59 150.56 90.35 151.28 88.93 150.46 90.18 149.74 91.59 150.56"
  })), _polygon87 || (_polygon87 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "93.36 151.57 92.12 152.29 90.7 151.48 91.94 150.76 93.36 151.57"
  })), _polygon88 || (_polygon88 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "85.55 150.38 86.8 149.66 88.22 150.47 86.97 151.19 85.55 150.38"
  })), _polygon89 || (_polygon89 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "87.32 151.4 88.56 150.67 89.98 151.49 88.74 152.21 87.32 151.4"
  })), _polygon90 || (_polygon90 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "89.08 152.41 90.33 151.69 91.75 152.51 90.5 153.23 89.08 152.41"
  })), _polygon91 || (_polygon91 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "83.94 151.31 85.19 150.59 86.6 151.41 85.36 152.13 83.94 151.31"
  })), _polygon92 || (_polygon92 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "85.71 152.33 86.95 151.61 88.37 152.42 87.13 153.14 85.71 152.33"
  })), _polygon93 || (_polygon93 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "87.47 153.35 88.72 152.62 90.14 153.44 88.89 154.16 87.47 153.35"
  })), _polygon94 || (_polygon94 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "84.99 152.34 83.75 153.06 82.33 152.25 83.58 151.53 84.99 152.34"
  })), _polygon95 || (_polygon95 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "86.76 153.36 85.52 154.08 84.1 153.26 85.34 152.54 86.76 153.36"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M424.31,270.54l9.79-5.68a1.31,1.31,0,0,1,1.34,0l23.22,13.41a.59.59,0,0,1,0,1l-9.57,5.55a1.56,1.56,0,0,1-1.59,0l-23.19-13.38A.53.53,0,0,1,424.31,270.54Z",
    transform: "translate(-346.41 -142.59)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M424.31,271.45l23.19,13.38a1.56,1.56,0,0,0,1.59,0l9.57-5.55a.6.6,0,0,0,.29-.51V280h0a.58.58,0,0,1-.29.5L449.09,286a1.59,1.59,0,0,1-1.59,0l-23.19-13.39a.53.53,0,0,1-.26-.46h0V271A.53.53,0,0,0,424.31,271.45Z",
    transform: "translate(-346.41 -142.59)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M424.31,271.45l23.19,13.38a1.54,1.54,0,0,0,.72.21v1.19a1.53,1.53,0,0,1-.72-.2l-23.19-13.39a.53.53,0,0,1-.26-.46h0V271A.53.53,0,0,0,424.31,271.45Z",
    transform: "translate(-346.41 -142.59)"
  })), _polygon96 || (_polygon96 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "103.29 128.84 85.25 118.39 85.25 127.33 103.29 137.77 103.29 128.84"
  })), _polygon97 || (_polygon97 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "87.76 116.95 85.25 118.39 103.29 128.84 105.81 127.39 87.76 116.95"
  })), _polygon98 || (_polygon98 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "105.81 127.39 103.29 128.84 103.29 137.77 105.81 136.31 105.81 127.39"
  })), _polygon99 || (_polygon99 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "67 72.89 121.86 104.71 121.86 145.07 67 113.13 67 72.89"
  })), _polygon100 || (_polygon100 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "121.86 104.71 123.68 103.6 123.68 143.97 121.86 145.07 121.86 104.71"
  })), _polygon101 || (_polygon101 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "67 72.89 68.87 71.81 123.68 103.6 121.86 104.71 67 72.89"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M413.41,215.49v40.24l54.86,31.94V247.3ZM467,285.41,414.71,255V217.74L467,248.05Z",
    transform: "translate(-346.41 -142.59)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M393.1,265.32c-.57,5.77-4.82,10.07-9.5,9.61s-8-5.51-7.43-11.28,4.82-10.06,9.49-9.6S393.67,259.56,393.1,265.32Z",
    transform: "translate(-346.41 -142.59)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M400.09,278.76s2,.49,2.74.56,3.38.63,4.47.3-1-1.06-1.47-1.43-.48-1.32.62-1.65,3.6-.18,4.92-.37-1.31-4.18-3.46-4.55a9.09,9.09,0,0,0-5.89.8c-1.83.9-2.83,2.43-3.68,2.72Z",
    transform: "translate(-346.41 -142.59)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M400.33,273.32l-13.91,3.49-.7,8.83L402.14,280C402.48,276.89,400.33,273.32,400.33,273.32Z",
    transform: "translate(-346.41 -142.59)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M366,277.06s-3.85,4.84,0,11.52c0,0,2.69,3.72,10.07.07Z",
    transform: "translate(-346.41 -142.59)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M377.43,271.4s6-.41,10.69,2.87a3.62,3.62,0,0,0,1.29,1.62c.94.63,5.61,2.5,5.61,2.5s-2.06,27.37.3,40.7c0,0-10.13,7.91-26,0,0,0-2.31-33.61-3.33-42C366,277.06,368.67,273.8,377.43,271.4Z",
    transform: "translate(-346.41 -142.59)"
  })), _polygon102 || (_polygon102 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "28.38 173.99 0 157.58 9.55 185.25 37.94 201.62 28.38 173.99"
  })), _polygon103 || (_polygon103 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "3.13 155.76 0 157.58 28.38 173.99 31.55 172.15 3.13 155.76"
  })), _polygon104 || (_polygon104 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "31.55 172.15 28.38 173.99 37.94 201.62 41.14 199.78 31.55 172.15"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M418.79,290.89s1.55-1.56,2.14-2,2.67-2.41,3.84-2.67-.82,1.77-1.07,2.4,1.2-.51,2.29-.92a5.39,5.39,0,0,1,3.72.13c2.69,1,2.56,6.33.36,5.7-3.61-1-5.23,1.82-7.39,2.42a21.71,21.71,0,0,1-3.05.56Z",
    transform: "translate(-346.41 -142.59)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M395,278.39l11.73,15.55,12.2-3.6s2.62,3.3,1.77,6.79l-16.28,6.34-13.23-14.55S386.78,279.68,395,278.39Z",
    transform: "translate(-346.41 -142.59)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M388.48,249.12s.9,2.17-3.42,2.76-9.65,2.73-11.06,7.29c-.9,2.91.14,6,1.61,8.58a16.48,16.48,0,0,0,1.71,2.5,9.33,9.33,0,0,0,6.37-1.09,11.06,11.06,0,0,0,3.43-4.18s2.57,1.07,3.37-1.07c.59-1.58,2.45-2,3.46-2.83C394,261.08,399.78,251.55,388.48,249.12Z",
    transform: "translate(-346.41 -142.59)"
  })), _polygon105 || (_polygon105 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "203.15 189.34 184.34 178.43 184.34 185.47 203.15 196.35 203.15 189.34"
  })), _polygon106 || (_polygon106 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "203.78 167.26 184.34 178.43 203.15 189.34 222.61 178.16 203.78 167.26"
  })), _polygon107 || (_polygon107 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "222.61 178.16 203.15 189.34 203.15 196.35 222.61 185.09 222.61 178.16"
  })), _polygon108 || (_polygon108 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "203.15 177.84 184.34 166.92 184.34 173.96 203.15 184.84 203.15 177.84"
  })), _polygon109 || (_polygon109 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "203.78 155.75 184.34 166.92 203.15 177.84 222.61 166.65 203.78 155.75"
  })), _polygon110 || (_polygon110 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "222.61 166.65 203.15 177.84 203.15 184.84 222.61 173.58 222.61 166.65"
  })), _polygon111 || (_polygon111 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "171.34 207.76 152.54 196.84 152.54 203.88 171.35 214.76 171.34 207.76"
  })), _polygon112 || (_polygon112 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "171.98 185.67 152.54 196.84 171.34 207.76 190.81 196.57 171.98 185.67"
  })), _polygon113 || (_polygon113 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "190.81 196.57 171.34 207.76 171.35 214.76 190.81 203.5 190.81 196.57"
  })), _polygon114 || (_polygon114 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "171.34 196.25 152.54 185.34 152.54 192.37 171.35 203.26 171.34 196.25"
  })), _polygon115 || (_polygon115 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "171.98 174.17 152.54 185.34 171.34 196.25 190.81 185.07 171.98 174.17"
  })), _polygon116 || (_polygon116 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "190.81 185.07 171.34 196.25 171.35 203.26 190.81 192 190.81 185.07"
  })), _polygon117 || (_polygon117 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "139.54 226.17 120.74 215.26 120.74 222.29 139.54 233.18 139.54 226.17"
  })), _polygon118 || (_polygon118 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "140.18 204.09 120.74 215.26 139.54 226.17 159.01 214.99 140.18 204.09"
  })), _polygon119 || (_polygon119 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "159.01 214.99 139.54 226.17 139.54 233.18 159.01 221.92 159.01 214.99"
  })), _polygon120 || (_polygon120 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "139.54 214.66 120.74 203.75 120.74 210.79 139.54 221.67 139.54 214.66"
  })), _polygon121 || (_polygon121 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "140.18 192.58 120.74 203.75 139.54 214.66 159.01 203.48 140.18 192.58"
  })), _polygon122 || (_polygon122 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "159.01 203.48 139.54 214.66 139.54 221.67 159.01 210.41 159.01 203.48"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M491.82,350.37l-1.18-.69a10.7,10.7,0,0,1-2.77.67v1H485v-1a10.9,10.9,0,0,1-2.77-.67l-1.17.69-2-1.18,1.18-.68a3.76,3.76,0,0,1-1.16-1.6h-1.66v-1.67H479a3.73,3.73,0,0,1,1.14-1.6L479,343l2-1.18,1.18.68a11.14,11.14,0,0,1,2.76-.66v-1h2.87v1a11.3,11.3,0,0,1,2.78.66l1.17-.68,2,1.18-1.18.68a3.7,3.7,0,0,1,1.16,1.6h1.66v1.66H493.8a3.73,3.73,0,0,1-1.14,1.6l1.18.68Zm-8.06-2.75a5.89,5.89,0,0,0,5.33,0c1.46-.86,1.45-2.24,0-3.09a5.87,5.87,0,0,0-5.32,0c-1.47.85-1.46,2.23,0,3.09",
    transform: "translate(-346.41 -142.59)"
  })), _polygon123 || (_polygon123 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "173.41 180.24 175.24 184.14 177.07 188.05 170.32 187 163.57 185.96 168.49 183.1 173.41 180.24"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M542.83,308.41c-1-.59-.56-1.44,1.38-2.57a8.62,8.62,0,0,1,2.56-1,2.67,2.67,0,0,1,1.85.16,1.35,1.35,0,0,1,.49.45,2.3,2.3,0,0,1,.23.51l1.78-.44a2.21,2.21,0,0,0-.47-.77,2.88,2.88,0,0,0-.76-.58,5.35,5.35,0,0,0-3.31-.61,10.25,10.25,0,0,0-4,1.39,5,5,0,0,0-2.39,2.28c-.24.73.11,1.36,1,1.91a5.22,5.22,0,0,0,2,.67l1.38-.8A5.29,5.29,0,0,1,542.83,308.41Z",
    transform: "translate(-346.41 -142.59)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M551.28,310.56a1.75,1.75,0,0,0,0-1.31,1.74,1.74,0,0,1-.14-.91.88.88,0,0,1,.49-.57,2,2,0,0,1,.88-.28,1.56,1.56,0,0,1,.83.19,1.87,1.87,0,0,1,.53.45,4.29,4.29,0,0,1,.29.5l1.76-.42a3,3,0,0,0-1.32-1.39,4.2,4.2,0,0,0-2.24-.56,4.56,4.56,0,0,0-2.3.64,3.23,3.23,0,0,0-.84.66,1.69,1.69,0,0,0-.33.69,2,2,0,0,0,.11.89,1.85,1.85,0,0,1,.12,1,.88.88,0,0,1-.49.6,1.79,1.79,0,0,1-.89.25,1.75,1.75,0,0,1-.93-.24,2.61,2.61,0,0,1-1.12-1.36l-1.53.89a3.42,3.42,0,0,0,1.44,1.33,4.41,4.41,0,0,0,2.34.63,4.81,4.81,0,0,0,2.38-.7A2.32,2.32,0,0,0,551.28,310.56Z",
    transform: "translate(-346.41 -142.59)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M559.43,309.63a4.27,4.27,0,0,0-2.24-.57,4.73,4.73,0,0,0-2.3.65,3,3,0,0,0-.83.66,1.47,1.47,0,0,0-.33.69,1.81,1.81,0,0,0,.11.88,2,2,0,0,1,.12,1,1,1,0,0,1-.49.6,1.9,1.9,0,0,1-.9.25,1.71,1.71,0,0,1-.92-.24,2.57,2.57,0,0,1-1.12-1.36l-1.53.89a3.33,3.33,0,0,0,1.43,1.33,4.53,4.53,0,0,0,2.34.63,4.85,4.85,0,0,0,2.39-.7,2.35,2.35,0,0,0,1-.94,1.73,1.73,0,0,0,0-1.32,1.82,1.82,0,0,1-.14-.9.94.94,0,0,1,.5-.58,2,2,0,0,1,.88-.27,1.48,1.48,0,0,1,.83.19,1.68,1.68,0,0,1,.52.45,3.22,3.22,0,0,1,.29.5l1.76-.43A3,3,0,0,0,559.43,309.63Z",
    transform: "translate(-346.41 -142.59)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M549.14,246.82l-18.27-10.53a1.69,1.69,0,0,0-1.82.07h0l-4,2.31,1.87,2.53.69.8v18.09a3,3,0,0,0,1.51,2.61l13.67,7.91.14.76,2.79,3.91,4.29-2.53h0l0,0h0a1.37,1.37,0,0,0,.65-1.17v-22A3.14,3.14,0,0,0,549.14,246.82Z",
    transform: "translate(-346.41 -142.59)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M544.87,249.33l-18.48-10.66a1.35,1.35,0,0,0-2,1.17V262a3,3,0,0,0,1.51,2.62l18.47,10.68a1.4,1.4,0,0,0,2.09-1.2V252A3.14,3.14,0,0,0,544.87,249.33Z",
    transform: "translate(-346.41 -142.59)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M545.73,275.26l0,0h0Z",
    transform: "translate(-346.41 -142.59)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M546.43,274.06V252a3,3,0,0,0-.22-1.06l4.29-2.47a3.19,3.19,0,0,1,.2,1v22a1.37,1.37,0,0,1-.65,1.17h0l0,0h0l-4.25,2.5A1.36,1.36,0,0,0,546.43,274.06Z",
    transform: "translate(-346.41 -142.59)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M570,202.83l-18.27-10.54a1.73,1.73,0,0,0-1.83.07h0l-4,2.32,1.87,2.52.69.8v18.09a3,3,0,0,0,1.51,2.62l13.67,7.9.14.76,2.79,3.91,4.29-2.52,0,0h0a1.35,1.35,0,0,0,.65-1.17v-22A3.1,3.1,0,0,0,570,202.83Z",
    transform: "translate(-346.41 -142.59)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M565.77,205.34l-18.48-10.67a1.36,1.36,0,0,0-2,1.18V218a3,3,0,0,0,1.51,2.61l18.47,10.68a1.39,1.39,0,0,0,2.08-1.2V208A3.1,3.1,0,0,0,565.77,205.34Z",
    transform: "translate(-346.41 -142.59)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M566.63,231.26l0,0h0Z",
    transform: "translate(-346.41 -142.59)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M567.32,230.06V208a2.94,2.94,0,0,0-.21-1.06l4.29-2.47a3.23,3.23,0,0,1,.19,1v22a1.35,1.35,0,0,1-.65,1.17h0l0,0-4.26,2.5A1.37,1.37,0,0,0,567.32,230.06Z",
    transform: "translate(-346.41 -142.59)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M509,203.15,490.7,192.61a1.73,1.73,0,0,0-1.83.07h0l-4,2.31,1.87,2.53.69.8v18.09a3,3,0,0,0,1.51,2.62l13.67,7.9.14.76,2.79,3.91,4.29-2.52,0,0h0a1.37,1.37,0,0,0,.65-1.17v-22A3.1,3.1,0,0,0,509,203.15Z",
    transform: "translate(-346.41 -142.59)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M504.7,205.66,486.22,195a1.35,1.35,0,0,0-2,1.18v22.11a3,3,0,0,0,1.51,2.62l18.47,10.68a1.39,1.39,0,0,0,2.08-1.2v-22A3.1,3.1,0,0,0,504.7,205.66Z",
    transform: "translate(-346.41 -142.59)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M505.55,231.58l0,0h0Z",
    transform: "translate(-346.41 -142.59)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M506.25,230.38v-22a2.94,2.94,0,0,0-.21-1.06l4.29-2.47a3.23,3.23,0,0,1,.19,1v22a1.37,1.37,0,0,1-.65,1.17h0l0,0-4.26,2.5A1.37,1.37,0,0,0,506.25,230.38Z",
    transform: "translate(-346.41 -142.59)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M469,160.49,450.71,150a1.73,1.73,0,0,0-1.83.07h0l-4,2.32,1.86,2.52.7.8v18.09a3,3,0,0,0,1.5,2.62l13.67,7.9.14.76,2.79,3.91,4.29-2.52,0,0h0a1.34,1.34,0,0,0,.66-1.17v-22A3.11,3.11,0,0,0,469,160.49Z",
    transform: "translate(-346.41 -142.59)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M464.7,163l-18.48-10.67a1.36,1.36,0,0,0-2,1.18v22.12a3,3,0,0,0,1.51,2.61l18.48,10.68a1.39,1.39,0,0,0,2.08-1.2v-22A3.09,3.09,0,0,0,464.7,163Z",
    transform: "translate(-346.41 -142.59)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M465.56,188.92l0,0h0Z",
    transform: "translate(-346.41 -142.59)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M466.26,187.72v-22a3.17,3.17,0,0,0-.21-1.06l4.28-2.47a3,3,0,0,1,.2,1v22a1.34,1.34,0,0,1-.66,1.17h0l0,0-4.25,2.5A1.39,1.39,0,0,0,466.26,187.72Z",
    transform: "translate(-346.41 -142.59)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M501.05,210a11.72,11.72,0,0,0-4.06-4.29,4.09,4.09,0,0,0-4.08-.41c-2,1.14-2.23,4.57-.68,8l-5,2.86,1.46,2.53,5-2.86a10.86,10.86,0,0,0,3.27,3.06,4.08,4.08,0,0,0,4.06.41C503.28,218.06,503.29,213.88,501.05,210Zm-1.49,6.81a2.62,2.62,0,0,1-2.6-.26,7.42,7.42,0,0,1-2.6-2.74c-1.43-2.48-1.43-5.16,0-6a2.62,2.62,0,0,1,2.6.26,7.62,7.62,0,0,1,2.6,2.75C501,213.31,501,216,499.56,216.81Z",
    transform: "translate(-346.41 -142.59)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M450,164.9a3.89,3.89,0,0,1,.84.65c.28.28.56.57.84.89l.52-1.19a8.88,8.88,0,0,0-2.19-1.87,3.27,3.27,0,0,0-1.87-.54,1.53,1.53,0,0,0-1.23.84,4.43,4.43,0,0,0-.43,2.11,7.91,7.91,0,0,0,.86,3.77,6.33,6.33,0,0,0,2.5,2.58,5.15,5.15,0,0,0,2.06.75v-1.53a5.8,5.8,0,0,1-1.91-.65c-1.25-.72-1.88-2-1.87-4a2.66,2.66,0,0,1,.49-1.87C449,164.54,449.42,164.55,450,164.9Z",
    transform: "translate(-346.41 -142.59)"
  })), _polygon124 || (_polygon124 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "109.72 25.86 108.6 25.21 108.59 27.51 106.61 26.36 106.61 27.65 108.59 28.8 108.58 31.07 109.7 31.71 109.71 29.45 111.69 30.59 111.7 29.3 109.71 28.15 109.72 25.86"
  })), _polygon125 || (_polygon125 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "115.7 31.61 115.71 29.32 114.59 28.67 114.58 30.96 112.6 29.82 112.6 31.11 114.58 32.26 114.57 34.52 115.69 35.17 115.7 32.9 117.68 34.05 117.68 32.76 115.7 31.61"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M551.31,203.94a1.75,1.75,0,0,0-.3,1.2v2.72c0,.5-.16.77-.48.8a2.55,2.55,0,0,1-1.38-.46V210a4.68,4.68,0,0,1,1.37,1.13,2.27,2.27,0,0,1,.48,1.44v2.61a3.78,3.78,0,0,0,.29,1.56,4,4,0,0,0,1,1.27,10.09,10.09,0,0,0,1.79,1.26v-1.74a3.1,3.1,0,0,1-1-.89,2.06,2.06,0,0,1-.26-1V213a3.45,3.45,0,0,0-1.65-2.74v-.1c1.09.45,1.64.14,1.66-.92v-2.5c0-.4.09-.65.27-.73s.51,0,1,.26v-1.74a7.15,7.15,0,0,0-1.78-.8A1,1,0,0,0,551.31,203.94Z",
    transform: "translate(-346.41 -142.59)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M561.64,215.09a2.18,2.18,0,0,1-.47-1.36V211a3.56,3.56,0,0,0-.68-2.2,7.58,7.58,0,0,0-2.35-1.88v1.74a3,3,0,0,1,1,.88,2,2,0,0,1,.26,1v2.5a3.63,3.63,0,0,0,1.67,2.85v.1a1.63,1.63,0,0,0-1.24-.13c-.29.14-.44.46-.44,1v2.58c0,.4-.09.65-.26.74s-.52,0-1-.27v1.74a4.28,4.28,0,0,0,2.37.84c.45-.09.68-.56.68-1.42v-2.61c0-.54.16-.84.47-.89a2.48,2.48,0,0,1,1.38.46v-1.84A4.85,4.85,0,0,1,561.64,215.09Z",
    transform: "translate(-346.41 -142.59)"
  })), _polygon126 || (_polygon126 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "180.3 110.33 186.02 116.55 186.03 114.96 182.08 110.81 186.04 110.99 186.04 109.4 180.3 109.38 180.3 110.33"
  })), _polygon127 || (_polygon127 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "186.61 118.24 188.21 119.16 191.39 111.27 189.78 110.35 186.61 118.24"
  })), _polygon128 || (_polygon128 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "191.94 112.81 191.94 114.4 195.89 118.78 191.93 118.37 191.92 119.96 197.67 120.36 197.67 119.41 191.94 112.81"
  })), _polygon129 || (_polygon129 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "73.83 81.28 73.83 82.35 78.33 84.94 78.33 83.87 73.83 81.28"
  })), _polygon130 || (_polygon130 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "73.83 83.23 73.83 84.3 78.33 86.9 78.33 85.83 73.83 83.23"
  })), _polygon131 || (_polygon131 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "73.83 85.19 73.83 86.26 78.33 88.85 78.33 87.78 73.83 85.19"
  })), _polygon132 || (_polygon132 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "107.77 107.79 107.77 106.72 80.01 90.71 80.01 91.78 107.77 107.79"
  })), _polygon133 || (_polygon133 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "73.83 87.14 73.83 88.21 78.33 90.81 78.33 89.74 73.83 87.14"
  })), _polygon134 || (_polygon134 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "73.83 89.1 73.83 90.17 78.33 92.76 78.33 91.69 73.83 89.1"
  })), _polygon135 || (_polygon135 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "107.77 109.74 107.77 108.67 80.01 92.67 80.01 93.73 107.77 109.74"
  })), _polygon136 || (_polygon136 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "73.83 94.96 73.83 96.03 78.33 98.63 78.33 97.56 73.83 94.96"
  })), _polygon137 || (_polygon137 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "73.83 96.92 73.83 97.99 78.33 100.58 78.33 99.51 73.83 96.92"
  })), _polygon138 || (_polygon138 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "73.83 104.74 73.83 105.81 78.33 108.41 78.33 107.33 73.83 104.74"
  })), _polygon139 || (_polygon139 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "73.83 106.7 73.83 107.77 78.33 110.36 78.33 109.29 73.83 106.7"
  })), _polygon140 || (_polygon140 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "97.52 120.36 80.01 110.26 80.01 111.33 97.52 121.43 97.52 120.36"
  })), _polygon141 || (_polygon141 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "98.44 120.89 98.44 121.97 107.77 127.34 107.77 126.27 98.44 120.89"
  })), _polygon142 || (_polygon142 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "88.81 113.38 80.01 108.31 80.01 109.38 88.81 114.45 88.81 113.38"
  })), _polygon143 || (_polygon143 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "89.73 113.92 89.73 114.98 107.77 125.39 107.77 124.32 89.73 113.92"
  })), _polygon144 || (_polygon144 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "105.39 117.08 105.39 118.15 107.77 119.52 107.77 118.45 105.39 117.08"
  })), _polygon145 || (_polygon145 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "92.48 107.68 80.01 100.49 80.01 101.56 92.48 108.75 92.48 107.68"
  })), _polygon146 || (_polygon146 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "87.37 89.09 80.01 84.84 80.01 85.91 87.37 90.16 87.37 89.09"
  })), _polygon147 || (_polygon147 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "99.44 96.05 88.3 89.62 88.3 90.69 99.44 97.12 99.44 96.05"
  })), _polygon148 || (_polygon148 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "92.94 94.26 85.1 89.73 85.1 90.8 92.94 95.33 92.94 94.26"
  })), _polygon149 || (_polygon149 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "101.18 99 93.87 94.79 93.87 95.86 101.18 100.08 101.18 99"
  })), _polygon150 || (_polygon150 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "102.1 99.54 102.1 100.61 107.77 103.88 107.77 102.81 102.1 99.54"
  })), _polygon151 || (_polygon151 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "81.46 89.59 81.46 90.66 87.37 94.07 87.37 93 81.46 89.59"
  })), _polygon152 || (_polygon152 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "105.45 103.43 88.3 93.53 88.3 94.6 105.45 104.5 105.45 103.43"
  })), _polygon153 || (_polygon153 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "95.63 103.63 84.42 97.16 84.42 98.23 95.63 104.7 95.63 103.63"
  })), _polygon154 || (_polygon154 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "105.45 109.29 96.55 104.16 96.55 105.23 105.45 110.36 105.45 109.29"
  })), _polygon155 || (_polygon155 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "104.47 114.59 93.41 108.21 93.41 109.28 104.47 115.66 104.47 114.59"
  })), _polygon156 || (_polygon156 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "98.44 113.07 98.44 114.14 104.47 117.62 104.47 116.55 98.44 113.07"
  })), _polygon157 || (_polygon157 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "82.18 103.69 80.01 102.44 80.01 103.51 82.18 104.76 82.18 103.69"
  })), _polygon158 || (_polygon158 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "86.25 106.04 86.25 107.11 97.52 113.61 97.52 112.54 86.25 106.04"
  })), _polygon159 || (_polygon159 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "85.33 105.51 83.11 104.23 83.11 105.3 85.33 106.58 85.33 105.51"
  })), _polygon160 || (_polygon160 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "95.44 113.29 83.11 106.18 83.11 107.25 95.44 114.36 95.44 113.29"
  })), _polygon161 || (_polygon161 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "109.72 101.99 109.72 102.28 110.96 103 110.96 102.7 109.72 101.99"
  })), _polygon162 || (_polygon162 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "109.72 102.53 109.72 102.82 110.96 103.54 110.96 103.24 109.72 102.53"
  })), _polygon163 || (_polygon163 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "109.72 103.07 109.72 103.36 110.96 104.08 110.96 103.78 109.72 103.07"
  })), _polygon164 || (_polygon164 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "119.07 109.29 119.07 109 111.42 104.59 111.42 104.88 119.07 109.29"
  })), _polygon165 || (_polygon165 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "109.72 103.61 109.72 103.9 110.96 104.61 110.96 104.32 109.72 103.61"
  })), _polygon166 || (_polygon166 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "109.72 104.14 109.72 104.44 110.96 105.15 110.96 104.86 109.72 104.14"
  })), _polygon167 || (_polygon167 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "119.07 109.83 119.07 109.54 111.42 105.13 111.42 105.42 119.07 109.83"
  })), _polygon168 || (_polygon168 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "109.72 105.76 109.72 106.06 110.96 106.77 110.96 106.48 109.72 105.76"
  })), _polygon169 || (_polygon169 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "109.72 106.3 109.72 106.59 110.96 107.31 110.96 107.01 109.72 106.3"
  })), _polygon170 || (_polygon170 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "109.72 108.45 109.72 108.75 110.96 109.47 110.96 109.17 109.72 108.45"
  })), _polygon171 || (_polygon171 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "109.72 108.99 109.72 109.29 110.96 110 110.96 109.71 109.72 108.99"
  })), _polygon172 || (_polygon172 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "116.25 112.76 111.42 109.98 111.42 110.27 116.25 113.05 116.25 112.76"
  })), _polygon173 || (_polygon173 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "116.5 112.91 116.5 113.2 119.07 114.68 119.07 114.39 116.5 112.91"
  })), _polygon174 || (_polygon174 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "113.85 110.84 111.42 109.44 111.42 109.73 113.85 111.13 113.85 110.84"
  })), _polygon175 || (_polygon175 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "114.1 110.98 114.1 111.28 119.07 114.14 119.07 113.85 114.1 110.98"
  })), _polygon176 || (_polygon176 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "118.42 111.86 118.42 112.15 119.07 112.53 119.07 112.23 118.42 111.86"
  })), _polygon177 || (_polygon177 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "114.86 109.26 111.42 107.28 111.42 107.58 114.86 109.56 114.86 109.26"
  })), _polygon178 || (_polygon178 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "113.45 104.14 111.42 102.97 111.42 103.27 113.45 104.44 113.45 104.14"
  })), _polygon179 || (_polygon179 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "116.78 106.06 113.7 104.29 113.7 104.58 116.78 106.35 116.78 106.06"
  })), _polygon180 || (_polygon180 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "114.98 105.57 112.82 104.32 112.82 104.61 114.98 105.86 114.98 105.57"
  })), _polygon181 || (_polygon181 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "117.25 106.87 115.24 105.71 115.24 106.01 117.25 107.17 117.25 106.87"
  })), _polygon182 || (_polygon182 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "117.51 107.02 117.51 107.32 119.07 108.22 119.07 107.92 117.51 107.02"
  })), _polygon183 || (_polygon183 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "111.82 104.28 111.82 104.58 113.45 105.51 113.45 105.22 111.82 104.28"
  })), _polygon184 || (_polygon184 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "118.43 108.09 113.7 105.37 113.7 105.66 118.43 108.39 118.43 108.09"
  })), _polygon185 || (_polygon185 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "115.72 108.15 112.64 106.37 112.64 106.66 115.72 108.44 115.72 108.15"
  })), _polygon186 || (_polygon186 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "118.43 109.71 115.98 108.3 115.98 108.59 118.43 110 118.43 109.71"
  })), _polygon187 || (_polygon187 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "118.16 111.17 115.11 109.41 115.11 109.71 118.16 111.47 118.16 111.17"
  })), _polygon188 || (_polygon188 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "116.5 110.75 116.5 111.05 118.16 112 118.16 111.71 116.5 110.75"
  })), _polygon189 || (_polygon189 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "112.02 108.17 111.42 107.82 111.42 108.12 112.02 108.46 112.02 108.17"
  })), _polygon190 || (_polygon190 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "113.14 108.81 113.14 109.11 116.25 110.9 116.25 110.6 113.14 108.81"
  })), _polygon191 || (_polygon191 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "112.89 108.67 112.27 108.31 112.27 108.61 112.89 108.96 112.89 108.67"
  })), _polygon192 || (_polygon192 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "115.67 110.81 112.27 108.85 112.27 109.15 115.67 111.11 115.67 110.81"
  })), _polygon193 || (_polygon193 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "109.72 111.11 109.72 111.4 110.96 112.12 110.96 111.82 109.72 111.11"
  })), _polygon194 || (_polygon194 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "109.72 111.64 109.72 111.94 110.96 112.66 110.96 112.36 109.72 111.64"
  })), _polygon195 || (_polygon195 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "109.72 112.18 109.72 112.48 110.96 113.19 110.96 112.9 109.72 112.18"
  })), _polygon196 || (_polygon196 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "119.07 118.41 119.07 118.12 111.42 113.71 111.42 114 119.07 118.41"
  })), _polygon197 || (_polygon197 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "109.72 112.72 109.72 113.02 110.96 113.73 110.96 113.44 109.72 112.72"
  })), _polygon198 || (_polygon198 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "109.72 113.26 109.72 113.56 110.96 114.27 110.96 113.98 109.72 113.26"
  })), _polygon199 || (_polygon199 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "119.07 118.95 119.07 118.66 111.42 114.24 111.42 114.54 119.07 118.95"
  })), _polygon200 || (_polygon200 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "109.72 114.88 109.72 115.17 110.96 115.89 110.96 115.59 109.72 114.88"
  })), _polygon201 || (_polygon201 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "109.72 115.42 109.72 115.71 110.96 116.43 110.96 116.13 109.72 115.42"
  })), _polygon202 || (_polygon202 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "109.72 117.57 109.72 117.87 110.96 118.58 110.96 118.29 109.72 117.57"
  })), _polygon203 || (_polygon203 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "109.72 118.11 109.72 118.41 110.96 119.12 110.96 118.83 109.72 118.11"
  })), _polygon204 || (_polygon204 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "116.25 121.88 111.42 119.09 111.42 119.39 116.25 122.17 116.25 121.88"
  })), _polygon205 || (_polygon205 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "116.5 122.02 116.5 122.32 119.07 123.8 119.07 123.5 116.5 122.02"
  })), _polygon206 || (_polygon206 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "113.85 119.95 111.42 118.56 111.42 118.85 113.85 120.25 113.85 119.95"
  })), _polygon207 || (_polygon207 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "114.1 120.1 114.1 120.39 119.07 123.26 119.07 122.97 114.1 120.1"
  })), _polygon208 || (_polygon208 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "118.42 120.97 118.42 121.27 119.07 121.64 119.07 121.35 118.42 120.97"
  })), _polygon209 || (_polygon209 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "114.86 118.38 111.42 116.4 111.42 116.69 114.86 118.68 114.86 118.38"
  })), _polygon210 || (_polygon210 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "113.45 113.26 111.42 112.09 111.42 112.38 113.45 113.55 113.45 113.26"
  })), _polygon211 || (_polygon211 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "116.78 115.18 113.7 113.41 113.7 113.7 116.78 115.47 116.78 115.18"
  })), _polygon212 || (_polygon212 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "114.98 114.68 112.82 113.44 112.82 113.73 114.98 114.98 114.98 114.68"
  })), _polygon213 || (_polygon213 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "117.25 115.99 115.24 114.83 115.24 115.13 117.25 116.29 117.25 115.99"
  })), _polygon214 || (_polygon214 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "117.51 116.14 117.51 116.43 119.07 117.33 119.07 117.04 117.51 116.14"
  })), _polygon215 || (_polygon215 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "111.82 113.4 111.82 113.69 113.45 114.63 113.45 114.34 111.82 113.4"
  })), _polygon216 || (_polygon216 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "118.43 117.21 113.7 114.48 113.7 114.78 118.43 117.5 118.43 117.21"
  })), _polygon217 || (_polygon217 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "115.72 117.27 112.64 115.48 112.64 115.78 115.72 117.56 115.72 117.27"
  })), _polygon218 || (_polygon218 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "118.43 118.83 115.98 117.41 115.98 117.71 118.43 119.12 118.43 118.83"
  })), _polygon219 || (_polygon219 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "118.16 120.29 115.11 118.53 115.11 118.82 118.16 120.58 118.16 120.29"
  })), _polygon220 || (_polygon220 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "116.5 119.87 116.5 120.16 118.16 121.12 118.16 120.83 116.5 119.87"
  })), _polygon221 || (_polygon221 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "112.02 117.28 111.42 116.94 111.42 117.23 112.02 117.58 112.02 117.28"
  })), _polygon222 || (_polygon222 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "113.14 117.93 113.14 118.22 116.25 120.02 116.25 119.72 113.14 117.93"
  })), _polygon223 || (_polygon223 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "112.89 117.78 112.27 117.43 112.27 117.72 112.89 118.08 112.89 117.78"
  })), _polygon224 || (_polygon224 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "115.67 119.93 112.27 117.97 112.27 118.26 115.67 120.22 115.67 119.93"
  })), _polygon225 || (_polygon225 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "109.72 120.22 109.72 120.52 110.96 121.23 110.96 120.94 109.72 120.22"
  })), _polygon226 || (_polygon226 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "109.72 120.76 109.72 121.06 110.96 121.77 110.96 121.48 109.72 120.76"
  })), _polygon227 || (_polygon227 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "109.72 121.3 109.72 121.6 110.96 122.31 110.96 122.02 109.72 121.3"
  })), _polygon228 || (_polygon228 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "119.07 127.53 119.07 127.23 111.42 122.82 111.42 123.12 119.07 127.53"
  })), _polygon229 || (_polygon229 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "109.72 121.84 109.72 122.14 110.96 122.85 110.96 122.56 109.72 121.84"
  })), _polygon230 || (_polygon230 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "109.72 122.38 109.72 122.67 110.96 123.39 110.96 123.09 109.72 122.38"
  })), _polygon231 || (_polygon231 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "119.07 128.07 119.07 127.77 111.42 123.36 111.42 123.66 119.07 128.07"
  })), _polygon232 || (_polygon232 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "109.72 124 109.72 124.29 110.96 125 110.96 124.71 109.72 124"
  })), _polygon233 || (_polygon233 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "109.72 124.53 109.72 124.83 110.96 125.54 110.96 125.25 109.72 124.53"
  })), _polygon234 || (_polygon234 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "109.72 126.69 109.72 126.98 110.96 127.7 110.96 127.4 109.72 126.69"
  })), _polygon235 || (_polygon235 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "109.72 127.23 109.72 127.52 110.96 128.24 110.96 127.94 109.72 127.23"
  })), _polygon236 || (_polygon236 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "116.25 130.99 111.42 128.21 111.42 128.51 116.25 131.29 116.25 130.99"
  })), _polygon237 || (_polygon237 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "116.5 131.14 116.5 131.44 119.07 132.92 119.07 132.62 116.5 131.14"
  })), _polygon238 || (_polygon238 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "113.85 129.07 111.42 127.67 111.42 127.97 113.85 129.37 113.85 129.07"
  })), _polygon239 || (_polygon239 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "114.1 129.22 114.1 129.51 119.07 132.38 119.07 132.08 114.1 129.22"
  })), _polygon240 || (_polygon240 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "118.42 130.09 118.42 130.38 119.07 130.76 119.07 130.47 118.42 130.09"
  })), _polygon241 || (_polygon241 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "114.86 127.5 111.42 125.52 111.42 125.81 114.86 127.79 114.86 127.5"
  })), _polygon242 || (_polygon242 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "113.45 122.38 111.42 121.21 111.42 121.5 113.45 122.67 113.45 122.38"
  })), _polygon243 || (_polygon243 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "116.78 124.29 113.7 122.52 113.7 122.82 116.78 124.59 116.78 124.29"
  })), _polygon244 || (_polygon244 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "114.98 123.8 112.82 122.55 112.82 122.85 114.98 124.09 114.98 123.8"
  })), _polygon245 || (_polygon245 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "117.25 125.11 115.24 123.95 115.24 124.24 117.25 125.4 117.25 125.11"
  })), _polygon246 || (_polygon246 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "117.51 125.25 117.51 125.55 119.07 126.45 119.07 126.16 117.51 125.25"
  })), _polygon247 || (_polygon247 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "111.82 122.51 111.82 122.81 113.45 123.75 113.45 123.45 111.82 122.51"
  })), _polygon248 || (_polygon248 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "118.43 126.33 113.7 123.6 113.7 123.89 118.43 126.62 118.43 126.33"
  })), _polygon249 || (_polygon249 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "115.72 126.38 112.64 124.6 112.64 124.89 115.72 126.68 115.72 126.38"
  })), _polygon250 || (_polygon250 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "118.43 127.94 115.98 126.53 115.98 126.82 118.43 128.24 118.43 127.94"
  })), _polygon251 || (_polygon251 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "118.16 129.4 115.11 127.64 115.11 127.94 118.16 129.7 118.16 129.4"
  })), _polygon252 || (_polygon252 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "116.5 128.99 116.5 129.28 118.16 130.24 118.16 129.94 116.5 128.99"
  })), _polygon253 || (_polygon253 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "112.02 126.4 111.42 126.06 111.42 126.35 112.02 126.69 112.02 126.4"
  })), _polygon254 || (_polygon254 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "113.14 127.05 113.14 127.34 116.25 129.13 116.25 128.84 113.14 127.05"
  })), _polygon255 || (_polygon255 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "112.89 126.9 112.27 126.55 112.27 126.84 112.89 127.19 112.89 126.9"
  })), _polygon256 || (_polygon256 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "115.67 129.05 112.27 127.09 112.27 127.38 115.67 129.34 115.67 129.05"
  })), _polygon257 || (_polygon257 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "109.72 129.34 109.72 129.64 110.96 130.35 110.96 130.06 109.72 129.34"
  })), _polygon258 || (_polygon258 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "109.72 129.88 109.72 130.17 110.96 130.89 110.96 130.59 109.72 129.88"
  })), _polygon259 || (_polygon259 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "109.72 130.42 109.72 130.71 110.96 131.43 110.96 131.13 109.72 130.42"
  })), _polygon260 || (_polygon260 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "119.07 136.65 119.07 136.35 111.42 131.94 111.42 132.24 119.07 136.65"
  })), _polygon261 || (_polygon261 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "109.72 130.96 109.72 131.25 110.96 131.97 110.96 131.67 109.72 130.96"
  })), _polygon262 || (_polygon262 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "109.72 131.5 109.72 131.79 110.96 132.5 110.96 132.21 109.72 131.5"
  })), _polygon263 || (_polygon263 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "119.07 137.18 119.07 136.89 111.42 132.48 111.42 132.77 119.07 137.18"
  })), _polygon264 || (_polygon264 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "109.72 133.11 109.72 133.41 110.96 134.12 110.96 133.83 109.72 133.11"
  })), _polygon265 || (_polygon265 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "109.72 133.65 109.72 133.95 110.96 134.66 110.96 134.37 109.72 133.65"
  })), _polygon266 || (_polygon266 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "118.42 139.21 118.42 139.5 119.07 139.88 119.07 139.58 118.42 139.21"
  })), _polygon267 || (_polygon267 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "114.86 136.62 111.42 134.63 111.42 134.93 114.86 136.91 114.86 136.62"
  })), _polygon268 || (_polygon268 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "113.45 131.49 111.42 130.32 111.42 130.62 113.45 131.79 113.45 131.49"
  })), _polygon269 || (_polygon269 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "116.78 133.41 113.7 131.64 113.7 131.94 116.78 133.71 116.78 133.41"
  })), _polygon270 || (_polygon270 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "114.98 132.92 112.82 131.67 112.82 131.97 114.98 133.21 114.98 132.92"
  })), _polygon271 || (_polygon271 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "117.25 134.23 115.24 133.06 115.24 133.36 117.25 134.52 117.25 134.23"
  })), _polygon272 || (_polygon272 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "117.51 134.37 117.51 134.67 119.07 135.57 119.07 135.27 117.51 134.37"
  })), _polygon273 || (_polygon273 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "111.82 131.63 111.82 131.93 113.45 132.87 113.45 132.57 111.82 131.63"
  })), _polygon274 || (_polygon274 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "118.43 135.44 113.7 132.72 113.7 133.01 118.43 135.74 118.43 135.44"
  })), _polygon275 || (_polygon275 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "115.72 135.5 112.64 133.72 112.64 134.01 115.72 135.79 115.72 135.5"
  })), _polygon276 || (_polygon276 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "118.43 137.06 115.98 135.65 115.98 135.94 118.43 137.36 118.43 137.06"
  })), _polygon277 || (_polygon277 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "118.16 138.52 115.11 136.76 115.11 137.06 118.16 138.82 118.16 138.52"
  })), _polygon278 || (_polygon278 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "116.5 138.1 116.5 138.4 118.16 139.35 118.16 139.06 116.5 138.1"
  })), _polygon279 || (_polygon279 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "112.02 135.52 111.42 135.17 111.42 135.47 112.02 135.81 112.02 135.52"
  })), _polygon280 || (_polygon280 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "113.14 136.16 113.14 136.46 116.25 138.25 116.25 137.96 113.14 136.16"
  })), _polygon281 || (_polygon281 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "112.89 136.02 112.27 135.66 112.27 135.96 112.89 136.31 112.89 136.02"
  })), _polygon282 || (_polygon282 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "115.67 138.16 112.27 136.2 112.27 136.5 115.67 138.46 115.67 138.16"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M417.36,222.21l-1.48-.86a.11.11,0,0,0-.17.1v1.77a.23.23,0,0,0,.13.21l1.48.86a.11.11,0,0,0,.16-.1v-1.77A.22.22,0,0,0,417.36,222.21Z",
    transform: "translate(-346.41 -142.59)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M417.36,224.86l-1.48-.85a.11.11,0,0,0-.17.09v1.77a.23.23,0,0,0,.13.21l1.48.86a.11.11,0,0,0,.16-.1v-1.76A.25.25,0,0,0,417.36,224.86Z",
    transform: "translate(-346.41 -142.59)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M417.36,227.51l-1.48-.85a.11.11,0,0,0-.17.09v1.78a.26.26,0,0,0,.13.21l1.48.85a.1.1,0,0,0,.16-.09v-1.77A.25.25,0,0,0,417.36,227.51Z",
    transform: "translate(-346.41 -142.59)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M417.36,230.17l-1.48-.86a.11.11,0,0,0-.17.1v1.77a.23.23,0,0,0,.13.21l1.48.86a.11.11,0,0,0,.16-.1v-1.77A.22.22,0,0,0,417.36,230.17Z",
    transform: "translate(-346.41 -142.59)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M417.36,232.82l-1.48-.85a.11.11,0,0,0-.17.09v1.77a.23.23,0,0,0,.13.21l1.48.86a.11.11,0,0,0,.16-.1V233A.24.24,0,0,0,417.36,232.82Z",
    transform: "translate(-346.41 -142.59)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M417.36,235.47l-1.48-.85a.11.11,0,0,0-.17.09v1.78a.26.26,0,0,0,.13.21l1.48.85a.11.11,0,0,0,.16-.09v-1.77A.25.25,0,0,0,417.36,235.47Z",
    transform: "translate(-346.41 -142.59)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M417.36,238.13l-1.48-.86a.11.11,0,0,0-.17.1v1.77a.23.23,0,0,0,.13.21l1.48.86a.11.11,0,0,0,.16-.1v-1.77A.22.22,0,0,0,417.36,238.13Z",
    transform: "translate(-346.41 -142.59)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M417.36,240.78l-1.48-.86a.12.12,0,0,0-.17.1v1.77a.23.23,0,0,0,.13.21l1.48.86a.11.11,0,0,0,.16-.1V241A.24.24,0,0,0,417.36,240.78Z",
    transform: "translate(-346.41 -142.59)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M417.36,243.43l-1.48-.85a.11.11,0,0,0-.17.09v1.78a.23.23,0,0,0,.13.2l1.48.86a.11.11,0,0,0,.16-.09v-1.77A.25.25,0,0,0,417.36,243.43Z",
    transform: "translate(-346.41 -142.59)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M417.36,246.09l-1.48-.86a.11.11,0,0,0-.17.1v1.77a.24.24,0,0,0,.13.21l1.48.85a.1.1,0,0,0,.16-.09V246.3A.22.22,0,0,0,417.36,246.09Z",
    transform: "translate(-346.41 -142.59)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M417.36,248.74l-1.48-.86a.11.11,0,0,0-.17.1v1.77a.23.23,0,0,0,.13.21l1.48.86a.11.11,0,0,0,.16-.1V249A.24.24,0,0,0,417.36,248.74Z",
    transform: "translate(-346.41 -142.59)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M417.36,251.39l-1.48-.85a.11.11,0,0,0-.17.09v1.78a.23.23,0,0,0,.13.2l1.48.86a.11.11,0,0,0,.16-.1v-1.76A.25.25,0,0,0,417.36,251.39Z",
    transform: "translate(-346.41 -142.59)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "140.54 89.02 140.54 90.09 145.04 92.68 145.04 91.61 140.54 89.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "140.54 90.97 140.54 92.04 145.04 94.64 145.04 93.56 140.54 90.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "140.54 92.93 140.54 94 145.04 96.59 145.04 95.52 140.54 92.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "174.48 115.53 174.48 114.46 146.73 98.45 146.73 99.52 174.48 115.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "140.54 94.88 140.54 95.95 145.04 98.55 145.04 97.48 140.54 94.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "140.54 96.84 140.54 97.91 145.04 100.5 145.04 99.43 140.54 96.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "174.48 117.48 174.48 116.41 146.73 100.41 146.73 101.47 174.48 117.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "140.54 102.7 140.54 103.78 145.04 106.37 145.04 105.3 140.54 102.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "140.54 104.66 140.54 105.73 145.04 108.32 145.04 107.25 140.54 104.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "140.54 112.48 140.54 113.55 145.04 116.15 145.04 115.08 140.54 112.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "140.54 114.44 140.54 115.51 145.04 118.1 145.04 117.03 140.54 114.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "164.24 128.1 146.73 118 146.73 119.08 164.24 129.17 164.24 128.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "165.16 128.63 165.16 129.71 174.48 135.08 174.48 134.01 165.16 128.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "155.53 121.12 146.73 116.05 146.73 117.12 155.53 122.19 155.53 121.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "156.45 121.66 156.45 122.72 174.48 133.13 174.48 132.06 156.45 121.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "172.11 124.82 172.11 125.89 174.48 127.26 174.48 126.19 172.11 124.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "159.2 115.42 146.73 108.23 146.73 109.3 159.2 116.49 159.2 115.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "154.09 96.83 146.73 92.58 146.73 93.65 154.09 97.9 154.09 96.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "166.16 103.79 155.01 97.36 155.01 98.43 166.16 104.86 166.16 103.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "159.66 102 151.82 97.47 151.82 98.54 159.66 103.07 159.66 102"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "167.89 106.75 160.58 102.53 160.58 103.6 167.89 107.81 167.89 106.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "168.81 107.28 168.81 108.35 174.48 111.62 174.48 110.55 168.81 107.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "148.18 97.33 148.18 98.4 154.09 101.81 154.09 100.74 148.18 97.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "172.17 111.17 155.01 101.27 155.01 102.34 172.17 112.24 172.17 111.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "162.35 111.37 151.13 104.9 151.13 105.97 162.35 112.44 162.35 111.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "172.17 117.03 163.27 111.9 163.27 112.97 172.17 118.11 172.17 117.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "171.19 122.33 160.12 115.95 160.12 117.02 171.19 123.4 171.19 122.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "165.16 120.81 165.16 121.88 171.19 125.36 171.19 124.29 165.16 120.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "148.9 111.43 146.73 110.18 146.73 111.25 148.9 112.5 148.9 111.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "152.96 113.78 152.96 114.85 164.24 121.35 164.24 120.28 152.96 113.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "152.04 113.25 149.82 111.97 149.82 113.04 152.04 114.32 152.04 113.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "162.15 121.03 149.82 113.92 149.82 114.99 162.15 122.1 162.15 121.03"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "181.88 22 181.88 23.07 186.38 25.66 186.38 24.59 181.88 22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "181.88 23.95 181.88 25.02 186.38 27.62 186.38 26.55 181.88 23.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "181.88 25.91 181.88 26.98 186.38 29.57 186.38 28.5 181.88 25.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "215.82 48.51 215.82 47.44 188.07 31.43 188.07 32.5 215.82 48.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "181.88 27.87 181.88 28.94 186.38 31.53 186.38 30.46 181.88 27.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "181.88 29.82 181.88 30.89 186.38 33.49 186.38 32.41 181.88 29.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "215.82 50.47 215.82 49.4 188.07 33.39 188.07 34.46 215.82 50.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "181.88 35.69 181.88 36.76 186.38 39.35 186.38 38.28 181.88 35.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "181.88 37.64 181.88 38.71 186.38 41.31 186.38 40.24 181.88 37.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "181.88 45.47 181.88 46.54 186.38 49.13 186.38 48.06 181.88 45.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "181.88 47.42 181.88 48.49 186.38 51.09 186.38 50.01 181.88 47.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "205.57 61.09 188.07 50.99 188.07 52.06 205.57 62.16 205.57 61.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "206.5 61.62 206.5 62.69 215.82 68.07 215.82 67 206.5 61.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "196.86 54.11 188.07 49.03 188.07 50.1 196.86 55.18 196.86 54.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "197.78 54.64 197.78 55.71 215.82 66.11 215.82 65.04 197.78 54.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "213.45 57.8 213.45 58.88 215.82 60.24 215.82 59.17 213.45 57.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "200.54 48.4 188.07 41.21 188.07 42.28 200.54 49.47 200.54 48.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "195.43 29.81 188.07 25.57 188.07 26.64 195.43 30.88 195.43 29.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "207.49 36.77 196.35 30.34 196.35 31.41 207.49 37.84 207.49 36.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "201 34.98 193.15 30.46 193.15 31.53 201 36.05 201 34.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "209.23 39.73 201.92 35.51 201.92 36.58 209.23 40.8 209.23 39.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "210.15 40.26 210.15 41.33 215.82 44.6 215.82 43.53 210.15 40.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "189.51 30.31 189.51 31.38 195.43 34.79 195.43 33.72 189.51 30.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "213.51 44.15 196.35 34.26 196.35 35.33 213.51 45.22 213.51 44.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "203.68 44.35 192.47 37.88 192.47 38.95 203.68 45.42 203.68 44.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "213.51 50.02 204.61 44.88 204.61 45.95 213.51 51.09 213.51 50.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "212.52 55.32 201.46 48.94 201.46 50.01 212.52 56.39 212.52 55.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "206.5 53.8 206.5 54.87 212.52 58.34 212.52 57.27 206.5 53.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "190.24 44.42 188.07 43.17 188.07 44.24 190.24 45.49 190.24 44.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "194.3 46.76 194.3 47.83 205.57 54.34 205.57 53.26 194.3 46.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "193.38 46.23 191.16 44.95 191.16 46.02 193.38 47.3 193.38 46.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "203.49 54.02 191.16 46.91 191.16 47.98 203.49 55.09 203.49 54.02"
  }))), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M447,302a6,6,0,0,0-5.51.84c-3,2-5,4.73-3.78,5.75s3.57,2.11,5.1,1.56S451.9,305.16,447,302Z",
    transform: "translate(-346.41 -142.59)"
  })), _polygon283 || (_polygon283 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "163.5 147.74 139.94 161.09 124.92 152.4 148.48 139.06 163.5 147.74"
  })), _polygon284 || (_polygon284 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "144.55 160.77 144.55 161.29 168.11 147.8 168.11 147.42 144.55 160.77"
  })), _polygon285 || (_polygon285 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "168.11 147.42 144.55 160.77 129.54 152.08 153.09 138.74 168.11 147.42"
  })), _polygon286 || (_polygon286 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "144.55 160.77 144.55 161.29 129.54 152.6 129.54 152.08 144.55 160.77"
  })), _polygon287 || (_polygon287 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "152.93 140.16 162 145.39 161.61 145.62 152.53 140.39 152.93 140.16"
  })), _polygon288 || (_polygon288 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "151.99 140.7 161.06 145.93 160.66 146.15 151.59 140.92 151.99 140.7"
  })), _polygon289 || (_polygon289 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "149.8 141.94 162.29 149.15 161.89 149.37 149.4 142.16 149.8 141.94"
  })), _polygon290 || (_polygon290 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "148.93 142.43 161.42 149.64 161.03 149.86 148.53 142.65 148.93 142.43"
  })), _polygon291 || (_polygon291 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "148.07 142.92 160.56 150.13 160.16 150.35 147.67 143.14 148.07 142.92"
  })), _polygon292 || (_polygon292 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "147.2 143.41 159.69 150.62 159.3 150.84 146.81 143.63 147.2 143.41"
  })), _polygon293 || (_polygon293 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "146.34 143.9 158.83 151.11 158.43 151.34 145.94 144.13 146.34 143.9"
  })), _polygon294 || (_polygon294 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "145.47 144.39 157.97 151.6 157.57 151.83 145.08 144.62 145.47 144.39"
  })), _polygon295 || (_polygon295 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "144.61 144.88 157.1 152.09 156.7 152.32 144.21 145.11 144.61 144.88"
  })), _polygon296 || (_polygon296 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "143.74 145.37 156.24 152.58 155.84 152.81 143.35 145.6 143.74 145.37"
  })), _polygon297 || (_polygon297 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "142.88 145.86 155.37 153.07 154.97 153.3 142.48 146.09 142.88 145.86"
  })), _polygon298 || (_polygon298 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "142.01 146.35 154.51 153.56 154.11 153.79 141.62 146.58 142.01 146.35"
  })), _polygon299 || (_polygon299 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "141.15 146.84 153.64 154.06 153.24 154.28 140.75 147.07 141.15 146.84"
  })), _polygon300 || (_polygon300 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "140.29 147.34 152.78 154.54 152.38 154.77 139.89 147.56 140.29 147.34"
  })), _polygon301 || (_polygon301 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "139.42 147.83 151.91 155.04 151.51 155.26 139.02 148.05 139.42 147.83"
  })), _polygon302 || (_polygon302 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "138.56 148.32 151.05 155.53 150.65 155.75 138.16 148.54 138.56 148.32"
  })), _polygon303 || (_polygon303 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "137.69 148.81 150.18 156.02 149.79 156.24 137.29 149.03 137.69 148.81"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M473.92,298.1h-2.2v2.38h2.2a1.49,1.49,0,0,1,1.49,1.49v3.86a1.49,1.49,0,0,1-1.49,1.48h-3.23v2.38h3.23a3.87,3.87,0,0,0,3.87-3.86V302A3.88,3.88,0,0,0,473.92,298.1Z",
    transform: "translate(-346.41 -142.59)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M473.09,296.79v13.38c0,2.08-3.09,3.76-6.9,3.76s-6.91-1.68-6.91-3.76V296.79Z",
    transform: "translate(-346.41 -142.59)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M459.28,296.79c0,2.07,3.09,3.76,6.91,3.76s6.9-1.69,6.9-3.76S470,293,466.19,293,459.28,294.72,459.28,296.79Z",
    transform: "translate(-346.41 -142.59)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M460.66,296.74c0,1.63,2.47,2.94,5.53,2.94s5.53-1.31,5.53-2.94-2.48-2.93-5.53-2.93S460.66,295.12,460.66,296.74Z",
    transform: "translate(-346.41 -142.59)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M466.19,295.73c-2.42,0-4.47.83-5.23,2,.76,1.15,2.81,2,5.23,2s4.47-.83,5.22-2C470.66,296.56,468.61,295.73,466.19,295.73Z",
    transform: "translate(-346.41 -142.59)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M468.8,300.27v13.38a7.39,7.39,0,0,0,3.25-1.5V298.77A7.39,7.39,0,0,1,468.8,300.27Z",
    transform: "translate(-346.41 -142.59)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.b420bd10f00c9413f9d37e20ce487c10.svg";
export { ForwardRef as ReactComponent };